import { render, staticRenderFns } from "./CatalogTravelInfos.vue?vue&type=template&id=81f81d34&"
import script from "./CatalogTravelInfos.vue?vue&type=script&lang=js&"
export * from "./CatalogTravelInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports